import Api from '@/services/Index';

const sessionSchedule = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/sessions/instructor/schedule', config);
}


export default {
    sessionSchedule,
}
